// extracted by mini-css-extract-plugin
export default {"main":"Info_main__e4SHt","devider":"Info_devider__ySVBJ","title":"Info_title__laJJH","description":"Info_description__2UuLi","quantity":"Info_quantity__wFWbO"};